import React from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import classes from "./NavBar.module.css";
import CameraTwoToneIcon from "@material-ui/icons/CameraTwoTone";
import SentimentVerySatisfiedTwoToneIcon from "@material-ui/icons/SentimentVerySatisfiedTwoTone";
import LaptopMacTwoToneIcon from "@material-ui/icons/LaptopMacTwoTone";
import { Link} from "react-scroll";
import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import BookTwoToneIcon from '@material-ui/icons/BookTwoTone';

export default function NavBar() {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div>
      <div className={classes.menuPosition}>
        <IconButton
          ref={anchorRef}
          aria-controls={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <MenuIcon style={{color:"white"}}/>
        </IconButton>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="menu-list-grow"
                    className={classes.menuBackground}
                  >
                    <MenuItem onClick={handleClose}>
                      <Link to="intro" spy={true} smooth={true} className={classes.center}>
                        <SentimentVerySatisfiedTwoToneIcon />
                        About
                      </Link>
                    </MenuItem>
                    <MenuItem onClick={handleClose}>
                      <Link to="projects" spy={true} smooth={true} className={classes.center}>
                        <LaptopMacTwoToneIcon />
                        <span>Portfolio</span>
                      </Link>
                    </MenuItem>
                    <MenuItem onClick={handleClose}>
                      <Link to="photos" spy={true} smooth={true} className={classes.center}>
                        <CameraTwoToneIcon />
                        Photos
                      </Link>
                    </MenuItem>
                    <MenuItem onClick={handleClose}>
                        <Link to="blogs" spy={true} smooth={true} className={classes.center}>
                          <BookTwoToneIcon />
                          Blog
                        </Link>
                      </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
}
